import { combineReducers, createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import ui from './ui'
import reservation from './reservation'
import reservationChange from './reservationChange'
import { inactivityMiddleware } from '../middleware/inactivityMiddleware'
import adminUi from './adminUi'
import adminTerminals from './adminTerminals'
import terminal from './terminal'

const rootReducer = combineReducers({
  ui,
  reservation,
  reservationChange,
  adminUi,
  adminTerminals,
  terminal,
})

export const store = createStore(rootReducer, applyMiddleware(thunk, inactivityMiddleware))

export type AppState = ReturnType<typeof rootReducer>
